// scroll-effects.js
document.addEventListener("DOMContentLoaded", function() {
  const elements = document.querySelectorAll(".fade-scroll");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("fade-in");
      } else {
        entry.target.classList.remove("fade-in");
      }
    });
  }, { threshold: 0.15 });

  elements.forEach(el => observer.observe(el));
});